module.exports = __webpack_public_path__ + "static/img/4系统整体集成-off.b56855e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/4系统整体集成-off.png
// module id = A2aL
// module chunks = 0